import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=316d0c74&"
import script from "./TemplateView.vue?vue&type=script&lang=js&"
export * from "./TemplateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports